/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useTheme } from '@material-ui/core/styles';

export const Thumbnail = ({ children, className }) => {
  const theme = useTheme();

  return (
    <div
      className={className}
      css={css`
        border: 1px solid #313739;
        background-color: #222324;
        cursor: pointer;
        max-height: 95px;
        padding: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
        & > * {
          display: inline-flex;
        }
        & * {
          max-width: 100%;
          max-height: 100%;
        }
        ${theme.breakpoints.up('sm')} {
          max-height: none;
          padding: 15px;
        }
      `}
    >
      {children}
    </div>
  );
};
